import { render, staticRenderFns } from "./SupportModal.vue?vue&type=template&id=f2586004&scoped=true"
import script from "./SupportModal.vue?vue&type=script&lang=ts"
export * from "./SupportModal.vue?vue&type=script&lang=ts"
import style0 from "./SupportModal.vue?vue&type=style&index=0&id=f2586004&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2586004",
  null
  
)

export default component.exports